import React from 'react';

import {useCurrentUserPendingTasksQuery} from 'client/SignUp/NewSignUp/signUp.queries.generated';

import ForceOnboarding from './ForceOnboarding';

interface ForceOnboardingGateProps {
  children: React.ReactNode;
}

/**
 * Fetches the current user's pending signup tasks from GraphQL and hands them to
 * ForceOnboarding, which routes the user through the outstanding onboarding steps.
 */
export default function ForceOnboardingGate({children}: ForceOnboardingGateProps) {
  const {data: pendingData, loading: pendingLoading} = useCurrentUserPendingTasksQuery({
    fetchPolicy: 'network-only'
  });

  const pendingTasks = pendingData?.currentUser?.signupPending ?? [];
  const signupComplete = pendingData?.currentUser?.signupComplete ?? false;
  const isTeacher = pendingData?.currentUser?.isTeacher ?? false;

  return (
    <ForceOnboarding
      pendingSignupTasks={pendingTasks}
      signupComplete={signupComplete}
      pendingTasksLoading={pendingLoading}
      isTeacher={isTeacher}
    >
      {children}
    </ForceOnboarding>
  );
}
